import Icon, { sendIconTypes, outlines } from './Icon';

export { Icon, sendIconTypes, outlines };
